export default __webpack_public_path__ + "static/media/19.22ec7b5b.png";